module.exports = __webpack_public_path__ + "static/img/04.b18e4b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news8/04.jpg
// module id = gKTu
// module chunks = 1